// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"4665f7c6","878":"c09ab07a"}[chunkId] + ".chunk.js";
};